



















import mixins from 'vue-typed-mixins'
import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import { MultiselectOptions } from '@/UI/Shared/MultiselectOptions'
import Multiselect from 'vue-multiselect'
interface CustomMultiselectData {
  currentOption: MultiselectOptions | null;
}

export default mixins(FieldModel).extend({
  name: 'CustomMultiselect',
  components: { Multiselect },
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as () => MultiselectOptions[],
      required: true
    },
    trackBy: {
      type: String,
      default: 'id',
      required: false
    },
    labelBy: {
      type: String,
      default: 'label',
      required: false
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    }
  },
  data (): CustomMultiselectData {
    return {
      currentOption: null
    }
  },
  watch: {
    currentOption (newValue: MultiselectOptions | null): void {
      this.currentValue = newValue ? newValue.id : ''
      this.emitValue(this.currentValue)
    },
    options (): void {
      this.findCurrentValue()
    },
    value (): void {
      this.checkSelectedInput()
    }
  },
  methods: {
    findCurrentValue (): void {
      const selectedOption = this.options.find(current => {
        if (typeof (current.id) === 'string') {
          return current.id.toString() === this.currentValue.toString()
        } else { return current.id === parseInt(this.currentValue.toString()) }
      })
      this.currentOption = selectedOption === undefined ? null : selectedOption
    },
    checkSelectedInput (): void {
      if (this.value !== undefined) {
        this.currentValue = this.value
        this.findCurrentValue()
      }
    }
  },
  mounted (): void {
    this.checkSelectedInput()
  }
})
